import $ from 'jquery';
import ExtendableState from './ExtendableState';

export const composeMultiComponentSelector = names => names.split(',').map(name => composeComponentSelector(name.trim())).join(',');

export const composeComponentSelector = name => name ? `[data-component="${name}"]` : `[data-component]`;

class CoreComponent extends ExtendableState {
    constructor (selector, merger) {
        super(merger);
        this._selector = selector;
        this._clone = $(this._selector).clone();
    }

    connectedCallback() {}

    getSelector () {
        return this._selector;
    }

    getElement () {
        return $(this._selector);
    }

    buildObserverName(observerName) {
        return `${this.getID()}.${observerName}`;
    }

    subscribe(observerName, callback) {
        const key = this.buildObserverName(observerName);

        return $.observer.subscribe(key, callback);
    }

    publish(observerName) {
        const args = arguments;

        args[0] = this.buildObserverName(observerName);

        return $.observer.publish.apply(null, args);
    }

    getChild (selector, bySelector) {
        selector = (!bySelector) ? composeComponentSelector(selector): selector;
        return this.getChildren(selector, true)[0] || null;
    }

    getParent (selector = null) {
        return this.getClosest(composeComponentSelector(selector));
    }

    getChildren (selector = null, bySelector = false) {
        selector = (!bySelector) ? composeMultiComponentSelector(selector) : selector;
        return this.getElement().findComponents(selector);
    }

    getClosest (selector = null, bySelector = false) {
        selector = (!bySelector) ? composeComponentSelector(selector) : selector;
        return this.getElement().closestComponents(selector);
    }
}

export default CoreComponent;